import { render, staticRenderFns } from "./read_message.vue?vue&type=template&id=0c32b6a7&scoped=true"
import script from "./read_message.vue?vue&type=script&lang=js"
export * from "./read_message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c32b6a7",
  null
  
)

export default component.exports